export const safeGet = (
  obj: any,
  path: string | string[],
  defaultValue: any = undefined,
): any => {
  const segments = Array.isArray(path) ? path : path.split(".");

  if (!obj || !segments.length) {
    return defaultValue;
  }

  let result = obj;

  for (const key of segments) {
    if (result === null || typeof result !== "object") {
      return defaultValue;
    }

    const map = new Map(Object.entries(result));
    if (!map.has(key)) {
      return defaultValue;
    }

    result = map.get(key);
  }

  return result;
};
